import Modal from 'react-modal';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { useCart } from '@context/CartContext';
import { NewButton } from '@components/ui';
import { Caption2 } from '@components/styles/Typography';
import theme from '../../styles/themes';

Modal.setAppElement('#__next');
const ProductAddedAlert = ({ isOpen, onClose, discountRate }) => {
    const router = useRouter();
    const { t } = useTranslation();
    const { getCartQuery } = useCart();
    const onAfterModalOpen = () => {
        setTimeout(onClose, 3000);
    };

    const customStyles = {
        overlay: {
            zIndex: '999',
            backgroundColor: 'transparent',
        },
        content: {
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: discountRate > 0 ? '132px' : '109px',
            width: '100%',
            height: '100px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '25px 30px 52px 30px',
            borderRadius: '3px',
            zIndex: '999',
            border: 'none',
            boxShadow: '0 -8px 16px 0 rgba(40, 49, 59, 0.13)',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            overflow: 'hidden',
            backgroundColor: theme.colors.secondary,
        },
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            onAfterOpen={onAfterModalOpen}
            style={customStyles}
            contentLabel="Product Buy Modal"
        >
            <Wrapper>
                {getCartQuery.error ? (
                    <Caption2>{t('productAddedFail')}</Caption2>
                ) : (
                    <>
                        <Caption2 uppercase>{t('productAddedToCart')}</Caption2>
                        <br />
                        <NewButton
                            type="primary"
                            size="xlarge"
                            content={t('goToCart')}
                            handleClick={() => router.push('/cart')}
                            data-testid="added-alert-go-to-cart-button"
                        />
                    </>
                )}
            </Wrapper>
        </Modal>
    );
};

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export default ProductAddedAlert;
